export default __webpack_public_path__ + "static/media/papa.ec49cfed.Jpg";